import React from "react";
import { Route, Switch } from "react-router-dom";
import Calculate5GRewards from "../../pages/features/Calculate5GRewards";

const FeaturesRoutes: React.FC = () => {
  return (
    <Switch>
      <Route
        path="/helium-5g-genesis-mobile-rewards-calculator"
        component={Calculate5GRewards}
      />
    </Switch>
  );
};

export default FeaturesRoutes;
